import { TnABillableTimeOverviewDTO, TnABillableTimeOverviewSTO } from "../../models/tna-billable-time-overviews";
import { BaseApiService } from "../base/base-api.service";

export class TnABillableTimeOverviewsApiService extends BaseApiService<
  TnABillableTimeOverviewDTO,
  TnABillableTimeOverviewSTO
> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetTnABillableTimeOverviews",
    });
  }
}
